import { Search, Plus, Edit, Copy } from "lucide-react";
function ContractsBilling() {
  const contracts = [
    { id: 1, client: "Acme Corporation", jacket: "Spring Campaign 2026", poNumber: "PO-2026-001", startDate: "2026-01-01", endDate: "2026-12-31", rate: "$150/hr", billingCycle: "Monthly" },
    { id: 2, client: "Global Tech Inc", jacket: "Product Launch Q1", poNumber: "PO-2026-045", startDate: "2026-01-15", endDate: "2026-06-30", rate: "$175/hr", billingCycle: "Monthly" },
    { id: 3, client: "Stellar Industries", jacket: "Annual Support", poNumber: "PO-2026-012", startDate: "2026-02-01", endDate: "2027-01-31", rate: "$140/hr", billingCycle: "Monthly" },
    { id: 4, client: "NextGen Solutions", jacket: "Digital Transformation", poNumber: "PO-2026-089", startDate: "2026-02-15", endDate: "2026-08-15", rate: "$160/hr", billingCycle: "Bi-weekly" },
    { id: 5, client: "Prime Consulting", jacket: "Market Research 2026", poNumber: "PO-2026-033", startDate: "2026-01-01", endDate: "2026-12-31", rate: "$145/hr", billingCycle: "Monthly" },
    { id: 6, client: "Innovate Labs", jacket: "Innovation Workshop Series", poNumber: "PO-2026-067", startDate: "2026-03-01", endDate: "2026-09-30", rate: "$165/hr", billingCycle: "Monthly" }
  ];
  return <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Contracts & Billing Setup</h1>
        <p className="text-gray-600 dark:text-gray-400">Manage purchase orders, jackets, billing profiles, and contract rates</p>
      </div>

      {
    /* Search and Actions */
  }
      <div className="mb-6 flex items-center justify-between">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
          <input
    type="text"
    placeholder="Search contracts by client, jacket, or PO number..."
    className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  />
        </div>
        <button className="app-btn-gloss ml-4">
          <Plus className="w-5 h-5" />
          New Contract
        </button>
      </div>

      {
    /* Contracts Table */
  }
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Client</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Jacket</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">PO Number</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Start Date</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">End Date</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Rate</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Billing Cycle</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-800">
              {contracts.map((contract) => <tr key={contract.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                  <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">{contract.client}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">{contract.jacket}</td>
                  <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">{contract.poNumber}</td>
                  <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">{contract.startDate}</td>
                  <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">{contract.endDate}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">{contract.rate}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">{contract.billingCycle}</td>
                  <td className="px-6 py-4 text-sm">
                    <div className="flex items-center gap-2">
                      <button className="app-btn-plain p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors">
                        <Edit className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                      </button>
                      <button className="app-btn-plain p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors">
                        <Copy className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}
export {
  ContractsBilling
};
